export const SWAP_COLORS_DELAY = 100;
export const SWAP_POSITIONS_DELAY = 200;
